<script lang="ts">
import { defineComponent, toRefs } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import CoordinatorProvider from '../coordinator/CoordinatorProvider';
import FieldErrorMessage from './FieldErrorMessage.vue';

export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: Boolean,
    },
  },
  setup(props: { field: HekateDisplayField }) {
    const { field } = toRefs(props);

    return CoordinatorProvider.get().submitField({ field });
  },
});
</script>

<template>
  <div class="field-submit field-container">
    <field-error-message
      class="top-message"
      :messages="field.errorMessages"
    />
    <button
      type="submit"
      :disabled="field.isDisabled || isSubmitDisabled"
      :class="{ disabled: isSubmitDisabled || field.isDisabled }"
      @click.prevent="onClickSubmit"
    >
      {{ $t(submitText, '#no-key#') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@use '../../../style/vars.scss' as vars;

.field-submit {
  display: flex;
  flex-direction: column;
  width: 100%;

  .top-message {
    margin-top: 8px;
  }

  .recaptcha-box {
    margin-top: 6px;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  button {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -webkit-box-direction: normal;
    text-align: center;
    box-sizing: border-box;
    position: relative;
    word-wrap: break-word;
    font-size: 14px;
    margin: 10px auto 10px auto;
    letter-spacing: 0.5px;
    font-weight: normal;
    line-height: 1.2;
    display: inline-block;
    cursor: pointer;
    text-transform: uppercase;
    text-decoration: none;
    font-family: 'Rajdhani', 'Arial', sans-serif;
    vertical-align: middle;
    padding: 15px 30px;
    background-color: vars.$color-button-green;
    color: #fff;
    border: 3px solid vars.$color-button-green-border;
    transition: ease-in-out 0.3s;

    &.disabled {
      background: #ddd;
      border: 3px solid #ddd;
      &:hover {
        cursor: no-drop;
        background: #ccc;
      }
    }
  }
}
</style>
